import './App.css';
import { Container, Nav, Navbar } from 'react-bootstrap';
import data from './data/data';

import { useState, createContext } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';

import Home from './routes/Home';
import Detail from './routes/Detail';
import About from './routes/About';
import Footer from './Footer';
import Cart from './routes/Cart';

export let Context1 = createContext();

function App() {
  let [shoes, setShoes] = useState(data);
  let navigate = useNavigate();
  let [res, setRes] = useState([0,1,2,3,4,5,6,7,8]);
  let [remain, setRemain] = useState([10,11,12]);
  
  return (
    <div className="App">
      <Navbar bg="dark" variant="dark">
        <Container>
          <Navbar.Brand href="#home">ShoesShop</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link onClick={()=>{navigate('/')}}>Home</Nav.Link>
            <Nav.Link onClick={()=>{navigate('/detail/0')}}>Detail</Nav.Link>
            <Nav.Link onClick={()=>{navigate('/Cart')}}>Cart</Nav.Link>
            <Nav.Link onClick={()=>{navigate('/About')}}>About</Nav.Link>
          </Nav>
        </Container>
      </Navbar>

      {/* <Link to="/">홈</Link>
      <Link to="/detail">상세페이지</Link> */}

      <Routes>
        <Route path="/" element={<Home shoes={shoes} setShoes={setShoes} res={res} setRes={setRes}/>}/>
        <Route path="/detail/:id" element={
          <Context1.Provider value={{remain}}>
            <Detail shoes={shoes}/>
          </Context1.Provider>       
        }/>
        <Route path="/cart" element={<Cart/>}/>
        <Route path="/about" element={<About/>}>
          <Route path="member" element={<div>멤버입니다.</div>}/>
          <Route path="location" element={<div>위치입니다.</div>}/>
        </Route>
        <Route path="*" element={<div>없는 페이지입니다.</div>}/>
      </Routes>

      <Footer />
      
    </div>
  );
}

export default App;
